import React from "react";
import "../Page.css";
import firewall_icon from "../../Assets/security/firewall.svg";
import cors from "../../Assets/security/cors.png"
import document from "../../Assets/security/document.png"
import security_alert from "../../Assets/security/shield-alert.png"
import captcha from "../../Assets/security/captcha.png"
import SecurityCard1 from "./securityCards/SecurityCards";

const Firewall = () => {
    const requestAndInputProtection = [
        {
            title: "Web Application Firewall",
            description: "Stops Complex Attacks",
            logo: cors,
            status:1
        },
        {
            title: "Real-Time IP Blocklist",
            description: "Blocks requests from known malicious IPs",
            logo: document,
            status:1
        },
        {
            title: "Brute Force Protection",
            description: "Stops Password Guessing Attacks",
            logo: security_alert,
            status:1
        },
        {
          title: "Google reCAPTCHA",
          description: "Protect forms and endpoints from automated abuse and spam.",
          logo: captcha,
          status:1
        }
    ];

    return (
        <div className="DashboardPage" style={{ alignItems: "start", justifyContent: "start" ,flexDirection:"column",gap:"20px"}}>
            <div className="component-card">
                <div className="header_integration">
                    <div className="name_header_int">

                        <div className="int_heading_content">
                            <h4>Firewall</h4>
                        </div>

                    </div>
                    <img className="int_logo" src={firewall_icon} />

                </div>
                <div className="security_features">
                    {requestAndInputProtection.map((item, index) => (
                        <SecurityCard1
                            key={index}
                            logo={item.logo}
                            heading={item.title}
                            description={item.description}
                            status={item.status}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Firewall;